import { render, staticRenderFns } from "./DbMenuNav.vue?vue&type=template&id=29a3ab4a&"
import script from "./DbMenuNav.vue?vue&type=script&lang=ts&"
export * from "./DbMenuNav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports